const SortByOptions = Object.freeze({
  TIME: 'TIME',
  AUTHOR_FOLLOWER: 'AuthorFollower',
  SUBSCRIBER: 'Subscriber',
  RICHNESS: 'RICHNESS',
  RANDOM: 'RANDOM',
  OVERALL_STAR_RATING: 'OverallStarRating',
  OVERALL_SURVEY_SCORE: 'OverallSurveyScore',
  NET_PROMOTER_SCORE: 'NetPromoterScore',
  OVERALL_STAR_RATING_ASC: 'OverallStarRatingAsc',
  OVERALL_SURVEY_SCORE_ASC: 'OverallSurveyScoreAsc',
  NET_PROMOTER_SCORE_ASC: 'NetPromoterScoreAsc',
  MOST_RECENT: 'MostRecent',
  MOST_COMMENTED: 'MostCommented',
  MOST_LIKED: 'MostLiked',
  MOST_ENGAGEMENTS: 'MostEngagements',
  MOST_RETWEETS: 'MostRetweets',
  MOST_REPLIES: 'MostReplies',
  MOST_SHARED: 'MostShared',
  MOST_VIEWS: 'MostViews',
  HIGHEST_SENTIMENT: 'HighestSentiment',
  HIGHEST_PASSION: 'HighestPassion'
})
export default SortByOptions
// RESERVE BELOW
export type SortByOptionsStrings = typeof SortByOptions[keyof typeof SortByOptions]
